import React, { useState } from 'react'
import ButterToast, { Cinnamon } from 'butter-toast'
import { client } from '@Utils'
import { withRouter } from 'react-router-dom'
import { useStateValue } from '@State'
import { BasePage } from './BasePage'

const ReportingComp = () => {
  const [currentState, dispatch] = useStateValue()
  const [selectedAccts, setSelectedAccts] = useState([])
  const [startDate, setStartDate] = useState('')
  const [endDate, setEndDate] = useState('')
  const [createReport, setCreateReport] = useState(false)

  const handleAcctSelect = acctId => {
    let newSelActs = [...selectedAccts]
    if (newSelActs.indexOf(acctId) >= 0) {
      let filtered = newSelActs.filter(id => id !== acctId)
      setSelectedAccts(filtered)
    } else {
      newSelActs.push(acctId)
      setSelectedAccts(newSelActs)
    }
  }

  const handleSubmit = async () => {
    let data = {
      invoice_accounts: selectedAccts,
      start_date: startDate,
      end_date: endDate,
      create_report: createReport ? 1 : 0,
    }
    try {
      let resp = await client.post(
        '/account/invoice_account_enrollment.submit_breakdown_form/',
        data
      )
      dispatch({
        type: 'setBreakdownData',
        payload: resp.data.breakdown,
      })
      window.$('#widget_container').trigger('reload_widgets')
    } catch (err) {
      ButterToast.raise({
        content: (
          <Cinnamon.Crunch
            title="Error"
            content={`There was an error processing the form data. ${err}`}
            scheme={Cinnamon.Crisp.SCHEME_RED}
            icon={<i className="far fa-exclamation-triangle fa-3x" />}
          />
        ),
      })
    }
  }

  return (
    <div className="card-myed">
      <div>
        <b>Invoice Accounts:</b>
        <div className="border rounded mt-3 mb-4">
          {currentState.invoiceAccts.map(acct => (
            <div className="d-flex align-items-center pl-4" key={acct[0]}>
              <input
                className="mr-2"
                type="checkbox"
                onChange={() => handleAcctSelect(acct[0])}
              />
              <span>{acct[1]}</span>
            </div>
          ))}
        </div>
        <div className="mt-3 mb-4">
          <b>Start Date:</b>
          <div>
            <input
              type="date"
              className="form-control"
              onChange={e => setStartDate(e.target.value)}
            />
          </div>
        </div>
        <div className="mt-3 mb-4">
          <b>End Date:</b>
          <div>
            <input
              type="date"
              className="form-control"
              onChange={e => setEndDate(e.target.value)}
            />
          </div>
        </div>
      </div>
      <div className="mt-3 mb-4">
        <b>Create CSV Report:</b>
        <div style={{ width: '75px' }}>
          <select
            className="form-control"
            value={createReport}
            onChange={e => setCreateReport(e.target.value)}
          >
            <option value={false}>No</option>
            <option value={true}>Yes</option>
          </select>
        </div>
      </div>
      <div className="text-center">
        <button
          className="btn btn-myed btn-primary btn-primary-myed py-3"
          title="You must select at least one invoice account option before submitting."
          disabled={selectedAccts.length === 0}
          onClick={handleSubmit}
        >
          Submit
        </button>
      </div>
      {currentState.breakdown.map((bd, i) => (
        <React.Fragment key={i}>
          <h2>{bd.invoice_account_name}</h2>
          <table className="table table-striped">
            <thead>
              <tr>
                <th scope="col">Course Number</th>
                <th scope="col">Course Title</th>
                <th scope="col">School</th>
                <th scope="col">Enrollment Count</th>
              </tr>
            </thead>
            <tbody>
              {bd.courses.map((item, i) => (
                <tr key={i}>
                  <td className="w-25">{item.coursenum}</td>
                  <td className="w-25">{item.name}</td>
                  <td className="w-25">{item.school}</td>
                  <td className="w-25">{item.enrollment_count}</td>
                </tr>
              ))}
              <tr className="striped">
                <td>
                  <strong>Total Enrollment</strong>
                </td>
                <td></td>
                <td></td>
                <td>
                  <strong>{bd.total_enrollment}</strong>
                </td>
              </tr>
            </tbody>
          </table>
        </React.Fragment>
      ))}
    </div>
  )
}
export const Reporting = withRouter(ReportingComp)

export const ReportPage = () => {
  return (
    <React.Fragment>
      <BasePage Comp={ReportingComp} />
    </React.Fragment>
  )
}
